import Vue from "vue";
import Router from "vue-router";
//Layouts
import DashboardLayout from "@/views/Layout/DashboardLayout.vue";

import AuthLayout from "@/views/Layout/AuthLayout.vue";

//Store
import store from "@/store";

function lazyLoad(view) {
  return () => import(`./views/${view}.vue`);
}

Vue.use(Router);
let router = new Router({
  mode: "history",
  linkExactActiveClass: "active",
  props: true,
  routes: [


    //Logged in///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
      path: "/",
      redirect: "dashboard",
      component: DashboardLayout,
      meta: {
        title: "اِتِرِکس",
        metaTags: [
          {
            name: "description",
            content: "with general dashboard layout",
          },
          {
            property: "og:description",
            content: "with general dashboard layout",
          },
        ],
      },
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          //temprory redirect dashboard to users until we have data for dashboard
          redirect: "/users/all",
          component: lazyLoad("Dashboard"),
          props: true,
          meta: {
            title: "داشبورد",
            requiresAuth: true,
          },
        },
        {
          path: "/users/:type",
          name: "users",
          component: lazyLoad("Pages/Users/Users"),
          props: true,
          meta: {
            title: "کاربران",
            requiresAuth: true,
          },
        },
        {
          path: "/iban/",
          name: "iban",
          component: lazyLoad("Pages/Users/Iban"),
          props: true,
          meta: {
            title: "شبا های در انتظار تایید",
            requiresAuth: true,
          },
        },
        {
          path: "/cards/",
          name: "cards",
          component: lazyLoad("Pages/Users/Card"),
          props: true,
          meta: {
            title: "کارت های در انتظار تایید",
            requiresAuth: true,
          },
        },
        {
          path: "/user-profile/:id",
          name: "user-profile",
          component: lazyLoad("Pages/Users/UserProfile"),
          props: true,
          meta: {
            title: "پروفایل کاربر",
            requiresAuth: true,
          },
        },
        {
          path: "/setting/assets",
          name: "user-profile-assets",
          component: lazyLoad("Pages/Setting/Assets"),
          props: true,
          meta: {
            title: "مدیریت ارز ها",
            requiresAuth: true,
          },
        },
        {
          path: "/setting/asset/:symbol",
          name: "asset-profile",
          component: lazyLoad("Pages/Setting/AssetProfile"),
          props: true,
          meta: {
            title: "پروفایل ارز",
            requiresAuth: true,
          },
        },
        {
          path: "/setting/prices",
          name: "user-profile-prices",
          component: lazyLoad("Pages/Setting/Prices"),
          props: true,
          meta: {
            title: "مدیریت ارز ها",
            requiresAuth: true,
          },
        },
        {
          path: "/support",
          name: "support",
          redirect: "support/1",
          component: lazyLoad("Pages/Support/Tickets"),
          props: true,
          meta: {
            title: "پشتیبانی",
            requiresAuth: true,
          },
        },
        {
          path: "support/:page",
          name: "support-page",
          component: lazyLoad("Pages/Support/Tickets"),
          props: true,
          meta: {
            title: "پشتیبانی",
            parent: "support",
            requiresAuth: true,
          },
        },
        {
          path: "ticket-profile/:uid",
          name: "ticket-profile",
          component: lazyLoad("Pages/Support/TicketProfile"),
          props: true,
          meta: {
            title: "پشتیبانی",
            parent: "support",
            requiresAuth: true,
          },
        },
        {
          path: "/support-departments",
          name: "support-departments",
          component: lazyLoad("Pages/Support/Departments"),
          props: true,
          meta: {
            title: "دپارتمان ها",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/open-withdrawals",
          name: "reports/open-withdrawals",
          component: lazyLoad("Pages/Reports/OpenWithdrawals"),
          props: true,
          meta: {
            title: "دپارتمان ها",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/prefect-money-open-withdrawals",
          name: "reports-prefect-money-open-withdrawals",
          component: lazyLoad("Pages/Reports/PerfectMoneyOpenWithdrawals"),
          props: true,
          meta: {
            title: "تراکنش های ناموفق پرفکت مانی",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/transactions",
          name: "reports/transactions",
          component: lazyLoad("Pages/Reports/Transactions"),
          props: true,
          meta: {
            title: "تراکنش ها",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/fiat-transaction",
          name: "reports/fiat-transaction",
          component: lazyLoad("Pages/Reports/FiatTransactions"),
          props: true,
          meta: {
            title: "تراکنش ها",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/orders",
          name: "reports/orders",
          component: lazyLoad("Pages/Reports/Orders"),
          props: true,
          meta: {
            title: "تریدها",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/reward",
          name: "reports/reward",
          component: lazyLoad("Pages/Reports/Reward"),
          props: true,
          meta: {
            title: "جوایز",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/perfect-money",
          name: "reports/perfect-money",
          component: lazyLoad("Pages/Reports/PerfectMoney"),
          props: true,
          meta: {
            title: "پرفکت مانی",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/dusting",
          name: "reports/dusting",
          component: lazyLoad("Pages/Reports/Dusting"),
          props: true,
          meta: {
            title: "پرفکت مانی",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/totals",
          name: "reports/totals",
          component: lazyLoad("Pages/Reports/Totals"),
          props: true,
          meta: {
            title: "خریدوفروش",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/manual-fiat-deposit",
          name: "manual-fiat-deposit",
          component: lazyLoad("Pages/Reports/ManualFiatDeposit"),
          props: true,
          meta: {
            title: "خریدوفروش",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/manual-balance-change",
          name: "manual-balance-change",
          component: lazyLoad("Pages/Reports/ManualBalanceChange"),
          props: true,
          meta: {
            title: "آمار تراکنش های دستی ",
            requiresAuth: true,
          },
        },
        {
          path: "/reports/user-balances",
          name: "reports/user-balances",
          component: lazyLoad("Pages/Reports/UserBalances"),
          props: true,
          meta: {
            title: "موجودی سیستم",
            requiresAuth: true,
          },
        },
        {
          path: "/interview/agents",
          name: "interview/agents",
          component: lazyLoad("Pages/Interview/AgentsManage"),
          props: true,
          meta: {
            title: "پشتیبان‌ها",
            requiresAuth: true,
          },
        },
        {
          path: "/interview/rooms/:status?",
          name: "interview/rooms",
          component: lazyLoad("Pages/Interview/RoomsManage"),
          props: true,
          meta: {
            title: "اتاق‌ها",
            requiresAuth: true,
          },
        },
        {
          path: "/interview/room/:id",
          name: "interview/rooms/:id",
          component: lazyLoad("Pages/Interview/RoomProfile"),
          props: true,
          meta: {
            title: "اتاق‌ها",
            requiresAuth: true,
          },
        },
        {
          path: "/interview/setting",
          name: "interview/setting",
          component: lazyLoad("Pages/Interview/InterviewSetting"),
          props: true,
          meta: {
            title: "تنظیمات",
            requiresAuth: true,
          },
        },
        {
          path: "/setting/voucher",
          name: "/setting/voucher",
          component: lazyLoad("Pages/Setting/Voucher"),
          props: true,
          meta: {
            title: "تنظیمات ووچر",
            requiresAuth: true,
          },
        },
        {
          path: "/setting/announcement",
          name: "/setting/announcement",
          component: lazyLoad("Pages/Setting/Announcement"),
          props: true,
          meta: {
            title: "تنظیمات اطلاعیه ها",
            requiresAuth: true,
          },
        },

        /**
         * Reward center
         */
        {
          path: "/reward-center/rewards/create",
          name: "rewards.create",
          component: lazyLoad("Pages/Reward/Create"),
          props: true,
          meta: {
            title: "افزودن جایزه جدید",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/rewards/list",
          name: "rewards.list",
          component: lazyLoad("Pages/Reward/List"),
          props: true,
          meta: {
            title: "لیست جایزه ها",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/rewards/details/:id",
          name: "rewards.details",
          component: lazyLoad("Pages/Reward/Details"),
          props: true,
          meta: {
            title: "نمایش جزییات جایزه",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/rewards/conditions",
          name: "rewards.condition",
          component: lazyLoad("Pages/Reward/Condition"),
          props: true,
          meta: {
            title: "لیست شروط جایزه",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/achieved-rewards/calculated",
          name: "achieved-rewards.calculated",
          component: lazyLoad("Pages/Reward/AchievedRewards/Calculated"),
          props: true,
          meta: {
            title: "جایزه های دریافت شده",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/achieved-rewards/confirmed",
          name: "achieved-rewards.confirmed",
          component: lazyLoad("Pages/Reward/AchievedRewards/Confirmed"),
          props: true,
          meta: {
            title: "جایزه های تایید شده",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/achieved-rewards/paid",
          name: "achieved-rewards.paid",
          component: lazyLoad("Pages/Reward/AchievedRewards/Paid"),
          props: true,
          meta: {
            title: "جایزه های پرداخت شده",
            requiresAuth: true
          }
        },
        {
          path: "/reward-center/add-reward-to-user",
          name: "rewards.add-reward-to-user",
          component: lazyLoad("Pages/Reward/AddRewardToUser"),
          props: true,
          meta: {
            title: "اختصاص جایزه",
            requiresAuth: true
          }
        },

        /**
         * Treasury
         */
        {
          path: "/treasury",
          name: "Treasury",
          component: lazyLoad("Pages/Treasury/index"),
          props: true,
          meta: {
            title: "خزانه",
            requiresAuth: true
          }
        },


        {
          path: "/setting/operations",
          name: "Operations",
          component: lazyLoad("Pages/Operations/index"),
          props: true,
          meta: {
            title: "تنظیمات عملیات",
            requiresAuth: true
          }
        },
      ],
    },
    //Login and Register///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
      path: "/",
      redirect: "login",
      component: AuthLayout,
      children: [
        {
          path: "/login",
          name: "login",
          component: lazyLoad("Pages/Account/Login"),
          meta: {
            title: "Login",
            guest: true,
          },
        },
        {
          path: "/login-code",
          name: "login-code",
          component: lazyLoad("Pages/Account/LoginCode"),
          meta: {
            title: "کد تایید",
            guest: true,
          },
        },
      ],
    },

    { path: "*", component: lazyLoad("NotFoundPage"), props: { code: "404" } },
    { path: "/500", component: lazyLoad("NotFound"), props: { code: "500" } },
  ],
});

//Router Guards
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle)
    document.title = nearestWithTitle.meta.title + " | اِتِرِکس";
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else if (store.getters.isLoggedIn) {
      const access = router.app.$options.methods.checkAccess(to.path);

      if (access) {
        //if true
        next();
      } else {
        //false
        //send a message to show on dashboard
        next({
          name: "dashboard",
          path: "/dashboard",
          params: { showmsg: true, nextUrl: to.fullPath },
        });
      }
    } else {
      next("/login");
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem("token") == null) {
      next();
    } else {
      next({
        name: "dashboard",
        path: "/dashboard",
        params: { showmsg: true, nextUrl: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;
